<template>
  <div class="presupuesto-interno-renglones">
    <b-card header="Ordenes de Trabajo">
      <b-table
          :key="key"
          small 
          responsive="sm"
          :busy="tableBusy"
          :class="{ 
            'registro-ordenes': true, 
            'cotizacion-interna': tieneRecargoServicioPropio,
            'cotizacion-final': consultarCotizacionFinal
          }"
          :items="ordenesTrabajoDatos" 
          :fields="renglonesFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(tieneImagenes)="data">
          <template v-if="data.item.tieneImagenes">
            <i class="fa fa-image"></i>
          </template>
        </template>
        <template v-slot:cell(rubroTrabajo)="data">
          {{ data.item.rubroTrabajo }}
        </template>
        <template v-slot:cell(costoInterno)="data">
          {{ data.item.costoInterno | moneda(data.item.moneda) }}
        </template>
        <template v-slot:cell(pjeRentabilidad)="data">
            <template v-if="data.item.cotizacionInterna == 0">
              {{ '--.--%' }}
            </template>
            <template v-if="data.item.costoInterno == 0 && data.item.cotizacionInterna != 0">
              {{ '100.00%' }}
            </template>
            <input
                type="number" 
                step="0.01"
                v-model="data.item.pjeRentabilidad"
                v-if="data.item.costoInterno != 0 && data.item.cotizacionInterna != 0"
                @focus="$event.target.select()"
                @keyup.enter.prevent="actualizarPjeRentabilidadRenglon(data.item)"
                @change="actualizarPjeRentabilidadRenglon(data.item)"/>
        </template>
        <template v-slot:cell(pjeImpuestos)="data">
          {{ data.item.pjeImpuestos | porcentaje }}
        </template>
        <template v-slot:cell(cotizacionInterna)="data">
          <template v-if="data.item.cotizacionInternaDisabled">
            {{ data.item.cotizacionInterna | moneda(data.item.moneda) }}
          </template>
          <template v-if="!data.item.cotizacionInternaDisabled">
            <app-formatted-cotizacion
              :ordenTrabajoId="data.item.id"
              :importe="data.item.cotizacionInterna"
              :moneda="data.item.moneda"
              @actualizarImporte="actualizarCotizacionInternaRenglon">
            </app-formatted-cotizacion>
            <!-- <input 
                type="number"
                v-model="data.item.cotizacionInterna"
                @focus="$event.target.select()"
                @keyup.enter.prevent="actualizarCotizacionInternaRenglon(data.item)"
                @change="actualizarCotizacionInternaRenglon(data.item)"/> -->
          </template>
        </template>
        <template v-slot:cell(cotizacion)="data">
          <template v-if="data.item.cotizacionDisabled">
            {{ data.item.cotizacion | moneda(data.item.moneda) }}
          </template>
          <template v-if="!data.item.cotizacionDisabled">
            <app-formatted-cotizacion
              :id="data.item.id"
              :importe="data.item.cotizacion"
              :moneda="data.item.moneda"
              @actualizarImporte="actualizarCotizacionRenglon">
            </app-formatted-cotizacion>
            <!-- <input 
                type="number"
                v-model="data.item.cotizacion"
                @focus="$event.target.select()"
                @keyup.enter.prevent="actualizarCotizacionRenglon(data.item)"
                @change="actualizarCotizacionRenglon(data.item)"/> -->
          </template>
        </template>
        <template v-slot:cell(cotizacionFinal)="data">
          {{ data.item.cotizacionFinal | moneda(data.item.moneda) }}
        </template>
        <template v-slot:cell(observaciones)="data">
          <span v-if="data.item.certificado" class="col-certificado">*</span>
          <span v-if="data.item.tieneAlternativas" class="col-alternativas">*</span>
        </template>
        <!-- {{ data.item.certificado ? "*" : "" }} -->
        <template v-slot:cell(opciones)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item 
                @click.stop="editarOrden(data.item)">
              <i class="fa fa-edit"></i>Editar Datos de la Orden</b-dropdown-item>
              <b-dropdown-item
                v-if="accesoDescuentoOrden"
                @click.stop="editarDescuentoOrden(data.item)">
              <i class="fa fa-edit"></i>Editar Descuento de la Orden</b-dropdown-item>
            <b-dropdown-item
                v-if="accesoImagenes"
                :disabled="data.item.ordenTrabajoId == 0" 
                @click.stop="consultarImagenes(data.item)">
              <i class="fa fa-image"></i>Consultar Imágenes de la Orden</b-dropdown-item>
            <b-dropdown-item 
                :disabled="Boolean(data.item.certificado)"
                @click.stop="borrarOrden(data.item)">
              <i class="fa fa-remove"></i>Borrar Orden</b-dropdown-item>
            <b-dropdown-item 
                v-if="data.item.montoCertificado != 0 & data.item.montoCertificado != data.item.cotizacion & pjeDescuento == 0"
                @click.stop="ajustarMontoCertificado(data.item)">
              <i class="fa fa-edit"></i>Ajustar a Monto Certificado - {{ montoCertificadoRenglon(data.item.montoCertificado) | moneda(data.item.moneda) }}</b-dropdown-item>

            <b-dropdown-item
                v-if="accesoAlternativas & !data.item.tieneAlternativas & !confirmado"
                @click.stop="agregarAlternativa(data.item)">
              <i class="fa fa-plus"></i>Agregar Alternativa</b-dropdown-item>
            <b-dropdown-item
                v-if="accesoAlternativas & data.item.tieneAlternativas"
                @click.stop="consultarAlternativas(data.item)">
              <i class="fa fa-list"></i>Consultar Alternativas</b-dropdown-item>
          </b-dropdown>
        </template>

        <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              v-if= 'row.item.ordenTrabajo.descripcion != ""'
              @click.stop="row.item._showDetails = !row.item._showDetails">
            {{ row.item._showDetails ? '-' : '+' }}
          </b-btn>            
        </template>

        <!--<template v-slot:row-details="row" v-if="row.item.showDescripcion">-->
        <template v-slot:row-details="row">
          <b-row v-if='row.item.ordenTrabajo.descripcion != ""'>
            <b-col xl="12">
              <p class="orden-descripcion"> {{ row.item.ordenTrabajo.descripcion }} </p>
            </b-col>
          </b-row>
        </template>
      </b-table>

      <b-table 
          small 
          responsive="sm"
          :class="{ 
            'registro-ordenes': true, 
            'cotizacion-interna': tieneRecargoServicioPropio,
            'cotizacion-final': consultarCotizacionFinal,
            'totales': true 
          }"
          :items="ordenesTrabajoTotales" 
          :fields="totalesFields">
        <template v-slot:cell(costo)="data">
          <template v-if="data.item.costo">
            {{ data.item.costo | moneda(data.item.monedaSimbolo) }}
          </template>
        </template>
        <template v-slot:cell(cotizacion)="data">
          {{ data.item.cotizacion | moneda(data.item.monedaSimbolo) }}
        </template>
      </b-table>

      <b-row>
        <b-col>
          <small><span class="col-certificado">*</span> Órdenes certificadas total o parcialmente </small>
        </b-col> 
      </b-row>
      <b-row>
        <b-col>
          <small><span class="col-alternativas">*</span> Orden con alternativas </small>  
        </b-col> 
      </b-row>
      <b-row v-if="autorizado">
        <b-col>
          <small>Autorizado para registrar margenes inferiores al minimo ({{ usuarioAutorizacion }} - {{ fechaAutorizacion | fecha }}) </small>  
        </b-col> 
      </b-row>
    </b-card>
    
    <b-modal ref="ordenTrabajoImagenesModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalOrdenTrabajo">
      <app-orden-trabajo-imagenes
        :ordenTrabajoId="ordenTrabajoId"
        @close="closeImagenes">
      </app-orden-trabajo-imagenes>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import OrdenTrabajoImagenes from '../ordenestrabajos/Imagenes';
import FormattedCotizacionInterna from '../shared/formattedCurrency.vue';
import FormattedCotizacion from '../shared/formattedCurrency.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'PresupuestosInternosRenglones',
  components: {
    appOrdenTrabajoImagenes: OrdenTrabajoImagenes,
    appFormattedCotizacionInterna: FormattedCotizacionInterna,
    appFormattedCotizacion: FormattedCotizacion,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  props: {
    accesoImagenes: {
      type: Boolean,
      default: false
    },
    accesoAlternativas: {
      type: Boolean,
      default: false
    },
    accesoDescuentoOrden: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ordenTrabajoId: 0,

      labelCols: 2,
      tableBusy: false,
      key: 900
    }
  },
  computed: {
    ...mapFields([
      'clienteId',
      'monedaId',
      'pjeRecargoServicioPropio',
      'pjeDescuento',
      'confirmado',

      'ordenesTrabajoDatos',  
      'ordenesTrabajoTotales',

      'autorizado',
      'usuarioAutorizacion',
      'fechaAutorizacion'
    ]),
    monedaSimbolo() {
      if (this.monedaId) {
        if (this.monedaId == 102) {  
          return 'usd';
        }
      }
      return '$';
    },
    tieneRecargoServicioPropio() {
      return this.pjeRecargoServicioPropio != 0;
    },
    consultarCotizacionFinal() {
      if (this.clienteId) {
        if (this.clienteId == 58) {
          return true;
        }
      }
      return false;
    },
    renglonesFields() {
      let fields = [
        { 
            key: 'tieneImagenes',
            label: '',
            class: 'text-center'
        },
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'rubroTrabajo',
          label: 'Rubro',
          sortable: true
        },
        {
          key: 'titulo',
          sortable: true
        },
        { 
          key: 'cantidad', 
          class: "text-right" },
        { 
          key: 'costoInterno', 
          label: 'Costo Interno',
          class: "text-right" 
        },
        { 
          key: 'pjeRentabilidad', 
          class: "text-right", 
          label: '% Rent.Estimada' 
        },
      ]

      if (this.pjeRecargoServicioPropio != 0) {
        fields.push({ 
            key: 'cotizacionInterna', 
            class: "text-right", 
            label: 'Cotización Interna'
          });
      }
      fields.push({ 
        key: 'cotizacion', 
        class: "text-right", 
        label: 'Cotización'
      });
      if ((/true/i).test(this.consultarCotizacionFinal)) {
        fields.push({ 
          key: 'cotizacionFinal', 
          class: "text-right", 
          label: 'Cotiz. Final'
        });
      }
      fields.push({
        key: 'observaciones',
        // key: 'certificado',
        label: '',
        class: 'text-center'
      });
      fields.push({ 
        key: 'opciones',
        label: '',
        class: 'text-center'
      });
      
      return fields;
    },
    totalesFields() {
      let fields = [
        { key: 'blank_0'},
        { key: 'blank_1'},
        { key: 'blank_2'},
        { key: 'blank_3'},
        { key: 'blank_4'},
        { key: 'costo', class: "text-right"},
        { key: 'blank_6'}
      ]

      if (this.pjeRecargoServicioPropio != 0) {
        fields.push( { key: 'blank_7'} );
        fields.push({ 
            key: 'cotizacion', 
            class: "text-right", 
            label: 'Cotización'
          });
        fields.push( { key: 'blank_9'} );
        fields.push( { key: 'blank_10'} );
        if ((/true/i).test(this.consultarCotizacionFinal)) {
          fields.push( { key: 'blank_11'} );
        }
      } else {
        fields.push({ 
            key: 'cotizacion', 
            class: "text-right", 
            label: 'Cotización'
          });
        fields.push( { key: 'blank_8'} );
        fields.push( { key: 'blank_9'} );
        if ((/true/i).test(this.consultarCotizacionFinal)) {
          fields.push( { key: 'blank_10'} );
        }
      }
      
      return fields;
    }
  },  
  created() {
  },
  destroyed() {
  },
  methods: {
    // agregarOrden() {
    //   this.$emit('agregarOrden');
    // },
    refresh() {
      this.key++;
    },
    editarOrden(item) {
      this.$emit('editarOrden', item.ordenTrabajo);
    },
    editarDescuentoOrden(item) {
      this.$emit('editarDescuentoOrden', item.ordenTrabajo);
    },
    borrarOrden(item) {
      this.showModalConfirm('¿Desea eliminar la orden seleccionada del presupuesto?', 
        this.borrar.bind(this, item.id), 'Borrar', null, 'Cancelar');
    },
    borrar(ordenTrabajoId) {
      this.showSpinner();
      this.$store.dispatch('presupuestointerno/deleteOrden', ordenTrabajoId)
        .catch(error => this.showErrorMsj(error))
        .finally(() => {
          this.hideSpinner();
        });
    },
    actualizarPjeRentabilidadRenglon(item) {
      let params = {
        ordenTrabajoId: item.id,
        pjeRentabilidad: item.pjeRentabilidad
      }
      this.tableBusy = true;
      this.$store.dispatch('presupuestointerno/updatePjeRentabilidadOrden', params)
        .catch(error => this.showErrorMsj(error))      
        .finally(() => this.tableBusy = false);
    },    
    actualizarCotizacionRenglon(params) {
      params.ordenTrabajoId = params.id;
      params.cotizacion = params.importe;
      this.tableBusy = true;
      this.$store.dispatch('presupuestointerno/updateCotizacionOrden', params)
        .catch(error => this.showErrorMsj(error))      
        .finally(() => this.tableBusy = false);
    },   
    // actualizarCotizacionRenglon(item) {
    //   let params = {
    //     ordenTrabajo: item.ordenTrabajo,
    //     cotizacion: item.cotizacion
    //   }
      
    //   this.tableBusy = true;
    //   this.$store.dispatch('presupuestointerno/updateCotizacionOrden', params)
    //     .catch(error => this.showErrorMsj(error))      
    //     .finally(() => this.tableBusy = false);
    // },   
    actualizarCotizacionInternaRenglon(params) {
      params.cotizacion = params.importe;
      
      this.tableBusy = true;
      this.$store.dispatch('presupuestointerno/updateCotizacionInternaOrden', params)
        .catch(error => this.showErrorMsj(error))      
        .finally(() => this.tableBusy = false);
    },
    // actualizarCotizacionInternaRenglon(item) {
    //   let params = {
    //     ordenTrabajo: item.ordenTrabajo,
    //     cotizacion: item.cotizacionInterna
    //   }
      
    //   this.tableBusy = true;
    //   this.$store.dispatch('presupuestointerno/updateCotizacionInternaOrden', params)
    //     .catch(error => this.showErrorMsj(error))      
    //     .finally(() => this.tableBusy = false);
    // },
    montoCertificadoRenglon(montoCertificado) {
      if (this.pjeDescuento != 0) {
        return this.roundToTwo(parseFloat(montoCertificado) * (1 + parseFloat(this.pjeDescuento)));
      }
      return montoCertificado;
    },
    ajustarMontoCertificado(item) {
      this.showModalConfirm('¿Desea ajustar la cotización de la orden al monto actualmente certificado?', 
            this.ajustarMontoCertificadoRenglon.bind(this, item), 'Si', null, 'No');
    },
    ajustarMontoCertificadoRenglon(renglon) {
      this.tableBusy = true;
      this.$store.dispatch('presupuestointerno/ajustarMontoCertificado', renglon.ordenTrabajo)
        .catch(error => this.showErrorMsj(error))      
        .finally(() => this.tableBusy = false);
    },

    consultarImagenes(item) {
      if (item.ordenTrabajoId != 0) {
        this.ordenTrabajoId = item.ordenTrabajoId;
        this.$refs.ordenTrabajoImagenesModal.show()
      }
    },
    closeImagenes(params) {
      this.$refs.ordenTrabajoImagenesModal.hide();

      /* Actualizamos la información de la orden */
      this.$store.dispatch('presupuestointerno/setOrdenTieneImagen', params)
        .catch(error => this.showErrorMsj(error));
    },
    agregarAlternativa(item) {
      this.$emit('agregarOrdenAlternativa', item.ordenTrabajo);
    },
    consultarAlternativas(item) {
      this.$emit('consultarAlternativas', item.ordenTrabajo);
    },
    roundToTwo(num) {    
      return +(Math.round(num + 'e+2')  + 'e-2');
    },
  },
  watch: {
  }    
}
</script>